import { Loader2Icon } from "lucide-react";
import { useT } from "@/i18n";

export function BudgetLoading() {
  const { t } = useT();
  return (
    <div
      role="status"
      aria-label={t("common.loading")}
      className="flex flex-1 items-center justify-center p-16 text-muted-foreground"
    >
      <Loader2Icon className="size-6 animate-spin" />
    </div>
  );
}
